<template>
  <div class="hello" style="cursor: default">
    <div class="helloTop">
      <div class="one_1">发掘核心价值 助力企业实现良性增长</div>
      <div class="one_21">
        大米智课从人才规划，知识仓库，人才培训，人才分层解决企业一体化大米智课从人才规划，知识仓库，人才培训，人才分层解决企业一体化
      </div>
      <div class="one_2">
        <div class="one_3">
          <div
            v-for="(item, i) in items"
            :key="i"
            :class="['one_4', activeName == i ? 'active' : '']"
            @mouseenter="handleClick(i)"
          >
            <div style="color: #fff">
              <div>公司业绩增长</div>
              <div>大米智课培训平台注重人才分层,人才晋升。快速助力企业增长</div>
            </div>
          </div>
        </div>
        <div class="Two_1">
          <div v-for="(item, i) in items" :key="i">
            <template v-if="i == activeName">
              <img :src="item.img" alt="" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewTalents',
  data() {
    return {
      activeName: '0',
      items: [
        {
          title: '人才规划',
          img: require('../assets/HelloWorld/a_1.png'),
          imgg: require('../assets/数字人/32.png'),
          imgg2: require('../assets/数字人/35.png'),
        },
        {
          title: '知识仓库',
          img: require('../assets/HelloWorld/cahngjing/c_1.png'),
          imgg: require('../assets/数字人/31.png'),
          imgg2: require('../assets/数字人/36.png'),
        },
        {
          title: '人才培训',
          img: require('../assets/HelloWorld/cahngjing/c_2.png'),
          imgg: require('../assets/数字人/34.png'),
          imgg2: require('../assets/数字人/37.png'),
        },
        //   {
        //     title: "人才分层",
        //     img: require("../assets/HelloWorld/cahngjing/c_3.png"),
        //     imgg:require('../assets/数字人/33.png'),
        //     imgg2:require('../assets/数字人/30.png'),
        //   },
      ],
    }
  },
  methods: {
    handleClick(i) {
      this.activeName = i
    },
  },
}
</script>

<style lang="scss" scoped>
.el-icon-right {
  color: #ec5c06;
  font-size: 24px;
}
.one_6 {
  width: 24px;
  border-radius: 50%;
  height: 24px;
  background: #ffffff;
}
.one_5 {
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  line-height: 28px;
  &.active {
    color: #ffffff;
  }
}
.hello {
  width: 100%;
  background: #f7faff;
  // height: 887px;
  display: flex;
  justify-content: center;
  .helloTop {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .one_1 {
      font-size: 32px;
      font-weight: bold;
      color: #121221;
      margin: 50px 0 10px;
      text-align: center;
      height: 56px;
      font-size: 40px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 47px;
    }
    .one_2 {
      width: 1200px;
      // height: 490px;
      display: flex;
      justify-content: space-between;
      .one_3 {
        width: 435px;
        overflow-y: scroll;
        // background: #eb5b05;
        // height: 475px;
        padding: 40px 0;
        div:last-child {
          margin-bottom: 0;
        }
        .one_4 {
          background: #b61818;
          margin: 0 60px 20px;
          border-radius: 5px;
          overflow: hidden;
          transition: all 0.3s ease;
          height: 110px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 40px;
            // height: 30px;
            margin-right: 20px;
          }
          &.active {
            transition: all 0.3s ease;
            //   height: 262px;
            background: #eb5b05;
          }
        }
      }
      .Two_1 {
        width: 760px;
        // height: 490px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          // width: 680px;
          height: 372px;
          transform: scale(1);
          transition: all 0.3s ease;
        }
        img:hover {
          transform: scale(1.1);
          transition: all 0.3s ease;
        }
      }
    }
  }
}
.one_21 {
  font-size: 12px;
}
</style>
